import AddToCartMutation from 'assets/graphql/mutations/AddToCartMutation.graphql';
import CreateAnalyticsUserMutation from 'assets/graphql/mutations/CreateAnalyticsUserMutation.graphql';
import CartQuery from 'assets/graphql/queries/Cart.graphql';

import { sendOrderMutation } from 'common/services/utils/utmTracker';
import useAccount from 'composables/useAccount';

/**
 * Input for `AddToCartMutation` variables
 * @typedef {Object} AddToCartInput
 * @property {string} boxId
 * @property {string} activityId
 * @property {number} quantity
 * @property {boolean} isGroup
 * @property {string} source
 * @property {string} boxType
 * @property {string} sellingSpotId
 * @property {string} kindId
 * @property {string} campaignSlug
 * @property {string} landingSlug
 */

/**
 * @typedef {Object} AddToCartMutationResponse
 * @property {boolean} ok
 * @property {(Array|undefined)} errors
 * @property {(string|undefined)} redirect_url
 */

/**
 * Adds an item to cart
 * @param {AddToCartInput} input
 * @param {*} apollo - usually `this.$apollo`
 * @returns {AddToCartMutationResponse}
 */
export const addToCartService = async (input, apollo) => {
  let order = null;
  try {
    const cartResponse = await apollo.query({
      query: CartQuery,
    });
    order = cartResponse.data.cart;
  } catch (e) {
    // eslint-disable-next-line
    console.error('Could not get order', e);
    return {
      ok: false,
      errors: [e],
    };
  }

  let retObj = {};
  try {
    const response = await apollo.mutate({
      mutation: AddToCartMutation,
      variables: input,
    });
    retObj = response.data.update_cart_item;
  } catch (e) {
    // eslint-disable-next-line
    console.error('Could not update cart', e);
    return {
      ok: false,
      errors: [e],
    };
  }

  if (!order) {
    try {
      await sendOrderMutation(retObj.order.id, apollo);
    } catch (e) {
      // eslint-disable-next-line
      console.warn('Could not set utm values to order', e);
    }
  }

  // == Analytics Hub Integration

  // Google Analytics
  if ('gtag' in window) {
    const account = useAccount();
    const clientIdPromise = new Promise((resolve, reject) => {
      const tid = setTimeout(reject, 5 * 1000);
      const gid =
        process.env.ENVIRONMENT === 'prod' ? 'G-F456QE2G2K' : 'G-ES49ZXLH4W';
      window.gtag('get', gid, 'client_id', cid => {
        clearTimeout(tid);
        resolve(cid);
      });
    });
    const client_id = await clientIdPromise;

    try {
      await apollo.mutate({
        mutation: CreateAnalyticsUserMutation,
        variables: {
          input: {
            provider: 'GA4',
            user: account.getUserData.value.id ?? '',
            client_id,
          },
        },
      });
    } catch (e) {
      // eslint-disable-next-line
      console.warn('Could not set the Google Analytics user', e);
    }
  }

  return retObj;
};
